@if (booking) {
  <div class="">
    <!-- Main header -->
    <div class="flex h-16 items-center justify-between border-b border-gray-200 p-4">
      <div class="flex items-center">
        <i class="pi pi-wallet mr-3 text-xl text-primary"></i>
        <h5 class="m-0 text-lg font-medium">{{ 'booking.detail.billingInfo' | translate }}</h5>
      </div>
    </div>

    <!-- Form content -->
    <div class="p-4">
      <!-- Billing Information - Connected group -->
      <div class="mb-7">
        <div class="mb-3 flex items-center">
          <i class="pi pi-credit-card mr-2 text-primary"></i>
          <h6 class="text-md m-0 font-medium ">{{ 'booking.detail.billingDetails' | translate }}</h6>
        </div>
        <div class="rounded-lg bg-gray-50 p-4 dark:bg-gray-800">
          <div class="grid">
            <!-- Billing Name -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="billing-name"
                class="mb-2 block text-sm font-medium "
              >
                {{ 'booking.detail.billingName' | translate }}
              </label>
              <input
                id="billing-name"
                type="text"
                pInputText
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('billing_name') }"
                [(ngModel)]="booking.billing_name"
                (ngModelChange)="onFieldChange('billing_name', $event)"
                [disabled]="loading"
              />
            </div>

            <!-- Billing Country -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="billing-country"
                class="mb-2 block text-sm font-medium "
              >
                {{ 'booking.detail.billingCountry' | translate }}
              </label>
              <app-country-select
                [value]="booking.billing_country"
                (valueChange)="booking.billing_country = $event || undefined; onFieldChange('billing_country', $event)"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('billing_country') }"
                [disabled]="loading"
              >
              </app-country-select>
            </div>

            <!-- Billing Zip/Postal Code -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="billing-postcode"
                class="mb-2 block text-sm font-medium "
              >
                {{ 'booking.detail.billingPostcode' | translate }}
              </label>
              <input
                id="billing-postcode"
                type="text"
                pInputText
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('billing_pocode') }"
                [(ngModel)]="booking.billing_pocode"
                (ngModelChange)="onFieldChange('billing_pocode', $event)"
                [disabled]="loading"
              />
            </div>

            <!-- Billing City -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="billing-city"
                class="mb-2 block text-sm font-medium "
              >
                {{ 'booking.detail.billingCity' | translate }}
              </label>
              <input
                id="billing-city"
                type="text"
                pInputText
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('billing_city') }"
                [(ngModel)]="booking.billing_city"
                (ngModelChange)="onFieldChange('billing_city', $event)"
                [disabled]="loading"
              />
            </div>

            <!-- Billing County/State -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="billing-county"
                class="mb-2 block text-sm font-medium "
              >
                {{ 'booking.detail.billingCounty' | translate }}
              </label>
              <input
                id="billing-county"
                type="text"
                pInputText
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('billing_county') }"
                [(ngModel)]="booking.billing_county"
                (ngModelChange)="onFieldChange('billing_county', $event)"
                [disabled]="loading"
              />
            </div>

            <!-- Billing Address Line 1 -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="billing-address1"
                class="mb-2 block text-sm font-medium "
              >
                {{ 'booking.detail.billingAddress1' | translate }}
              </label>
              <input
                id="billing-address1"
                type="text"
                pInputText
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('billing_address_line1') }"
                [(ngModel)]="booking.billing_address_line1"
                (ngModelChange)="onFieldChange('billing_address_line1', $event)"
                [disabled]="loading"
              />
            </div>

            <!-- Billing Address Line 2 -->
            <div class="col-12 md:col-6 lg:col-4 mb-4">
              <label
                for="billing-address2"
                class="mb-2 block text-sm font-medium "
              >
                {{ 'booking.detail.billingAddress2' | translate }}
              </label>
              <input
                id="billing-address2"
                type="text"
                pInputText
                class="w-full"
                [ngClass]="{ 'border-primary': changeTracker.isFieldChanged('billing_address_line2') }"
                [(ngModel)]="booking.billing_address_line2"
                (ngModelChange)="onFieldChange('billing_address_line2', $event)"
                [disabled]="loading"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Additional billing sections can be added here -->
    </div>
  </div>
} @else {
  <div class="card shadow-sm">
    <div class="flex min-h-[300px] flex-col items-center justify-center p-5">
      <div class="mb-4 flex flex-col items-center">
        <i class="pi pi-spin pi-spinner mb-3 text-3xl text-primary"></i>
        <h5 class="text-xl font-medium ">{{ 'common.loading' | translate }}</h5>
      </div>
      <p class="">{{ 'booking.detail.loadingBillingInfo' | translate }}</p>
    </div>
  </div>
}
